import { render, staticRenderFns } from "./WastenotificationsGrid.vue?vue&type=template&id=996a995c"
import script from "./WastenotificationsGrid.vue?vue&type=script&lang=js"
export * from "./WastenotificationsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports